// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-3ca328b9]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.pagination-container[data-v-3ca328b9] {\n  background: #fff;\n  padding: 32px 16px;\n}\n.pagination-container.hidden[data-v-3ca328b9] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
